import Scene = Phaser.Scene;
import {Creature} from "@/store/level/types";
import CreaturePanel from "@/scenes.ui/creature-panel";
import {SceneName} from "@/model/scene-name";
import {CreatureUtils} from "@/utils/creature-utils";
import {AbstractNavPanel} from "@/scenes.ui/abstract-nav-panel";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export default class ProfileCreaturesNavPanel extends AbstractNavPanel {

    private creatures!: Creature[];

    private onCreaturePanelPressCallback: (sceneName: SceneName, params: any) => void;

    constructor(scene: Scene, canvas: HTMLCanvasElement, x: number, y: number, creatures: Creature[],
                onCreaturePanelPressCallback: (sceneName: SceneName, params: any) => void, maxDisplayedElements: number) {
        super(scene, canvas, x, y, creatures, maxDisplayedElements);

        this.x = x * CU.S;
        this.y = y * CU.S;

        this.creatures = creatures;

        this.onCreaturePanelPressCallback = onCreaturePanelPressCallback;
    }

    protected makePanel(x: number, element: any): any {

        let creaturePanel = new CreaturePanel(this.scene!, x, 30, <Creature>element, () => undefined, true);
        creaturePanel.setHealthVisible();
        creaturePanel.setDepth(1000);
        SpriteUtils.scale(creaturePanel, 0.7 / CU.S);

        creaturePanel.setCallback(() => {
            if (this.onCreaturePanelPressCallback != null) {
                this.playSelectSound();

                // Собираю массив постоянных и сортирую
                let crs = CreatureUtils.sortCreaturesDescending(CreatureUtils.findNonTemporalCreatures(this.creatures));

                let creatureIndex;

                // Если юнит временный - ищу последнего возможного постоянного (скорее всего это мужик)
                if (creaturePanel.getCreature().temporal) {
                    creatureIndex = crs.length - 1;
                } else {
                    creatureIndex = crs.indexOf(creaturePanel.getCreature());
                }

                this.onCreaturePanelPressCallback(SceneName.CREATURE_SCENE,
                    { creatureIndex: creatureIndex, enemyProfile: this.isEnemyProfile(creaturePanel), creatures: this.creatures });

            }
        });

        return creaturePanel;

    }

    protected getButtonX(): number {
        return 250;
    }

    protected getButtonY(): number {
        return 30;
    }

    protected calculateCellWidth(creaturesAmount: number): number {
        return creaturesAmount <= 3 ? 110 : 90;
    }

    private isEnemyProfile(creaturePanel: CreaturePanel): boolean {
        return !CreatureUtils.exists(creaturePanel.getCreature().id);
    }


}